module.exports = __webpack_public_path__ + "dd26ad33844de1c0136b8c94ae2f8fc1.pdf";